import { useMemo, type FunctionComponent } from 'react';
import { useInfo, useToken } from '../../../Flow/ConsentContextProvider';
import ConsentDetails, { type DetailEntry } from '../../shared/agent-consent/Details/Details';
import { a2aDetailsMessages } from './messages';

/**
 * A2A-specific details component.
 * Renders Name and Redirect URL rows.
 */
const A2ADetails: FunctionComponent = () => {
  const { clientName, redirectUrl } = useToken();
  const { client } = useInfo();

  const redirectUrls = useMemo(() => {
    const seen = new Set<string>();
    const urls: string[] = [];
    const add = (u: string | undefined | null) => {
      const t = u?.trim();
      if (t && !seen.has(t)) {
        seen.add(t);
        urls.push(t);
      }
    };
    add(redirectUrl?.callback);
    (client?.callbacks ?? []).forEach(add);
    return urls;
  }, [redirectUrl, client?.callbacks]);

  const entries: DetailEntry[] = [
    { label: a2aDetailsMessages.nameLabel, value: clientName ?? '' },
    ...(redirectUrls.length > 0
      ? [{ label: a2aDetailsMessages.domainLabel, value: redirectUrls }]
      : []),
  ];

  return (
    <ConsentDetails
      title={a2aDetailsMessages.detailsTitle}
      entries={entries}
    />
  );
};

export default A2ADetails;
